import { render, staticRenderFns } from "./ListMainCourses.vue?vue&type=template&id=016a745a&scoped=true&"
import script from "./ListMainCourses.vue?vue&type=script&lang=js&"
export * from "./ListMainCourses.vue?vue&type=script&lang=js&"
import style0 from "./ListMainCourses.vue?vue&type=style&index=0&id=016a745a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a745a",
  null
  
)

export default component.exports